import { DaisyDepositIntervals } from "../models/types/DaisyDepositIntervals";
import { responseHero } from "../utils/axiosInterceptor";

export const getDaisyDepositIntervals = (startDate: string, endDate: string): Promise<DaisyDepositIntervals> => {
    return new Promise<DaisyDepositIntervals>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/daisydepositintervals/${startDate}/${endDate}`).then((response) => {
            resolve(response.data as DaisyDepositIntervals);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};